import type { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, debounceTime, first, map, switchMap } from 'rxjs/operators';

export function asyncTrue<TValue>(checker: (current: TValue) => Observable<boolean>, old?: TValue | null): AsyncValidatorFn {
  return (c: AbstractControl): Observable<ValidationErrors | null> => {
    if (!c.valueChanges || c.value === old) {
      return of(null);
    }

    return c.valueChanges.pipe(
      debounceTime(600),
      switchMap(v => checker(v)),
      catchError(() => of(false)),
      map(exist => exist ? { unique: true } : null),
      first(),
    );
  };
}
